// extracted by css-extract-rspack-plugin
export default {"root":"root-TawPgB","svg__lh32G":"svg__lh32G-KThxid","svgLh32G":"svg__lh32G-KThxid","svg__rUr3X":"svg__rUr3X-p1LnQF","svgRUr3X":"svg__rUr3X-p1LnQF"};